<template>
  <b-card v-if="loaded" class="h-100 overflow-auto">
    <div class="mx-3">
      <div class="bg-soft bg-welcome">
        <b-row>
          <b-col class="pt-3 pl-4" cols="7">
            <h5 class="text-light">Bonjour {{ userObject.first_name }} !</h5>
            <p class="text-light">Voici les dernières activités</p>
          </b-col>
          <b-col class="align-self-end" cols="3">
            <img alt class="img-fluid pt-3" src="@/assets/images/welcome.png" />
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col cols="4" style="transform: translateY(-20px)">
          <h-e-profile-default
            :first-name="userObject.first_name"
            :last-name="userObject.last_name"
            size="xl"
            class="ml-3"
            v-if="!userObject.profile_picture"
          ></h-e-profile-default>
          <div class="profile-user-wid ml-3" v-else style="width: 80px">
            <img :src="userObject.profile_picture" alt class="img-thumbnail rounded-circle" />
          </div>
        </b-col>
        <b-col class="d-flex justify-content-center" cols="12" style="transform: translateY(-20px)">
          <h-b-action :positive="false" text="Voir mon profil" @click.native="goToProfile"> </h-b-action>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import { User_me } from '@/node-sdk'

export default {
  name: 'profile',

  data() {
    return {
      userObject: null,
      loaded: false,
    }
  },

  async mounted() {
    this.userObject = await User_me.get_user_me()
    this.loaded = true
  },

  methods: {
    goToProfile() {
      this.$router.push('/profile')
    },
  },
}
</script>

<style scoped>
.bg-welcome {
  background-color: #3c416b !important;
}
</style>
